module.exports = __webpack_public_path__ + "img/amex-logo.a9eddb34.svg";